import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Search } = Input;

@inject('BookingItemStore')
@observer
class BookingCategorySearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Category'),
                dataIndex: 'name',
                key: 'name',
                width: '80%'
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: id => (
                    <span>
                        <Button onClick={() => this.selectCategoryOnClick(id)} type='primary'>
                            {t('Select')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    categoryOnChange = e => {
        this.props.BookingItemStore.setCategorySearchValue(e.target.value);
        this.props.BookingItemStore.searchCategory();
    }

    // ON CLICK

    selectCategoryOnClick = categoryId => {
        this.props.BookingItemStore.searchCategorySelected(categoryId);
        this.props.BookingItemStore.setShowBookingCategorySearchModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            bookingCategoryFilter,
            categorySearchValue
        } = this.props.BookingItemStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder={t('Search Category')} value={categorySearchValue} onChange={this.categoryOnChange} />
                <Table columns={this.getColumns()} dataSource={bookingCategoryFilter} />
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingCategorySearchModalPage);
